import React from 'react';
import Cash from "../components/Cash";

const Redux = () => {

    return (
        <div>
            <Cash/>
        </div>
    );
};

export default Redux;